module.exports = __webpack_public_path__ + "static/JavaScript-d2427cc6fdc7a11685e9ea1c2cb14738.png";